import React, { useEffect } from "react";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";

const ones = [
  "", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine",
  "Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen",
  "Seventeen", "Eighteen", "Nineteen",
];
const tens = [
  "", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety",
];

const numberToWords = (num) => {
  if (num === 0) return "Zero";
  if (isNaN(num)) return "";

  const isNegative = num < 0;
  num = Math.abs(Math.round(num * 100)) / 100;

  const intPart = Math.floor(num);
  const decPart = Math.round((num - intPart) * 100);

  const convertGroup = (n) => {
    if (n === 0) return "";
    if (n < 20) return ones[n];
    if (n < 100) {
      const t = Math.floor(n / 10);
      const o = n % 10;
      return tens[t] + (o ? " " + ones[o] : "");
    }
    const h = Math.floor(n / 100);
    const rem = n % 100;
    return ones[h] + " Hundred" + (rem ? " " + convertGroup(rem) : "");
  };

  let words = "";

  if (intPart >= 10000000) {
    const cr = Math.floor(intPart / 10000000);
    words += convertGroup(cr) + " Crore ";
  }
  if (intPart >= 100000) {
    const lk = Math.floor((intPart % 10000000) / 100000);
    words += convertGroup(lk) + " Lakh ";
  }
  if (intPart >= 1000) {
    const th = Math.floor((intPart % 100000) / 1000);
    words += convertGroup(th) + " Thousand ";
  }
  if (intPart >= 100) {
    const h = Math.floor((intPart % 1000) / 100);
    words += convertGroup(h) + " Hundred ";
  }
  const last3 = intPart % 100;
  if (last3 > 0) {
    words += convertGroup(last3);
  }

  words = words.trim();

  if (decPart > 0) {
    words += " and " + convertGroup(decPart) + " Paise";
  }

  words = words || "Zero";

  if (isNegative) words = "Minus " + words;

  return words;
};

const BidSubmitConfirmationModal = React.forwardRef((props, ref) => {
  const { show, onHide, onConfirm, bidAmount, currency, itemCode, itemDescription, quantity, uom } = props;

  useEffect(() => {
    const handleEscapeKey = (event) => {
      if (event.key === "Escape" || event.keyCode === 27) {
        onHide?.();
      }
    };
    if (show) {
      document.addEventListener("keydown", handleEscapeKey);
    }
    return () => {
      document.removeEventListener("keydown", handleEscapeKey);
    };
  }, [show, onHide]);

  const numericAmount = parseFloat(bidAmount) || 0;
  const amountInWords = numberToWords(numericAmount);

  return (
    <Modal
      show={show}
      onHide={onHide}
      aria-labelledby="bid-confirm-modal-title"
      keyboard={false}
      size="md"
      ref={ref}
      centered
      backdrop="static"
    >
      <Modal.Header closeButton style={{ borderBottom: "1px solid #e5e7eb" }}>
        <Modal.Title id="bid-confirm-modal-title">
          <i className="bi bi-exclamation-triangle-fill" style={{ color: "#b45309", marginRight: "8px" }}></i>
          Confirm Bid Submission
        </Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ padding: "24px", background: "#f9fafb" }}>
        <div style={{ textAlign: "center", marginBottom: "20px" }}>
          <div style={{ fontSize: "13px", color: "#111827", fontWeight: 600, marginBottom: "6px" }}>
            You are about to submit a bid for
          </div>
          <div style={{ fontWeight: 800, fontSize: "16px", color: "#111827" }}>
            {itemCode}
          </div>
          {itemDescription && (
            <div style={{ fontSize: "13px", color: "#111827", fontWeight: 600, marginTop: "4px" }}>
              {itemDescription}
            </div>
          )}
          {quantity && (
            <div style={{ fontSize: "12px", color: "#111827", fontWeight: 600, marginTop: "4px" }}>
              Qty: <strong style={{ color: "#111827" }}>{quantity}</strong> {uom || ""}
            </div>
          )}
        </div>

        <div style={{ background: "#fff", border: "1px solid #e5e7eb", borderRadius: "8px", padding: "16px", textAlign: "center", marginBottom: "16px" }}>
          <div style={{ fontSize: "12px", color: "#111827", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: "6px" }}>
            Bid Amount
          </div>
          <div style={{ fontSize: "28px", fontWeight: 800, color: "#111827" }}>
            {currency} {numericAmount.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
          </div>
        </div>

        <div style={{ background: "#fff", border: "1px solid #e5e7eb", borderRadius: "8px", padding: "14px", marginBottom: "20px" }}>
          <div style={{ fontSize: "11px", color: "#111827", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: "4px" }}>
            Amount in Words
          </div>
          <div style={{ fontSize: "14px", fontWeight: 600, color: "#111827", fontStyle: "italic" }}>
            {amountInWords}
          </div>
        </div>

        <Row className="justify-content-center" style={{ gap: "12px" }}>
          <Col xs={5} md={4}>
            <button
              type="button"
              onClick={onHide}
              className="btn w-100"
              style={{
                background: "#f3f4f6",
                color: "#374151",
                border: "1px solid #d1d5db",
                borderRadius: "8px",
                padding: "10px 0",
                fontWeight: 600,
                fontSize: "14px",
              }}
            >
              <i className="bi bi-x-lg" style={{ marginRight: "6px" }}></i>
              No
            </button>
          </Col>
          <Col xs={5} md={4}>
            <button
              type="button"
              onClick={() => {
                onConfirm?.();
                onHide?.();
              }}
              className="btn w-100"
              style={{
                background: "#6aacb0",
                color: "#fff",
                border: "none",
                borderRadius: "8px",
                padding: "10px 0",
                fontWeight: 600,
                fontSize: "14px",
              }}
            >
              <i className="bi bi-check-lg" style={{ marginRight: "6px" }}></i>
              Confirm
            </button>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
});

BidSubmitConfirmationModal.displayName = "BidSubmitConfirmationModal";

export default BidSubmitConfirmationModal;
